
import CompanyTypeAppService from "@/apis.machine/CompanyTypeAppService";
import CurrentLogier from "@/apis/CurrentLogier";
import DtoFormCompany, {
  DtoFormCompanyMiezzFormItems,
} from "@/models.machine/DtoFormCompany";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import UiSelectOption from "@/models.machine/UiSelectOption";
import MiezzForm from "@/models/MiezzForm";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import CompanyForm from "../CompanyForm.vue";
@Options({
  components: {
    CompanyForm,
  },
})
export default class ServiceProviderCompanyEdit extends Vue {
  type = EnumCompanyType.ServiceProvider;
  form = new MiezzForm<DtoFormCompany, string>(
    "ServiceProviderManagement_Company_Edit"
  );

  created(): void {
    const logier = CurrentLogier.GetLogier();
    this.form.Items = DtoFormCompanyMiezzFormItems.copy().filter(
      (it) =>
        it.Prop != "JoinCompanyTypes" &&
        it.Prop != "ServiceProviderCompanyId" &&
        it.Prop != "SalesmanId" &&
        it.Prop != "Source" &&
        it.Prop != "BusinessScope" &&
        it.Prop != "Remark" &&
        it.Prop != "BuildSettlementBill"
    );
    for (const item of this.form.Items) {
      if (item.Prop == "NameZh") {
        if (logier?.CompanyType != EnumCompanyType.Platform) {
          item.Disabled = true;
        }
      }
    }
  }
}
